import { MainContainer } from "components/shared";
import { SettingLayout } from "layouts/SettingLayout";
import { InnerOptions } from "../InnerOptions";
import { Box } from "components/ui/Box";
import { CreateForm } from "./CreateForm";
import { InHomolog } from "utils/InHomolog";

export const HubCreateVehicle: React.FC = () => {
  const { options } = InnerOptions();
  return (
    <MainContainer>
      <InHomolog />
      <SettingLayout options={options}>
        <Box>
          <CreateForm />
        </Box>
      </SettingLayout>
    </MainContainer>
  );
};
